import { cn } from "@/lib/utils"
import { Badge } from "@/components/ui/badge"

import { Position } from "@/app/(app)/(paragraph)/dashboard/components/CollectorAvatars/types"

/**
 * Minimal has no background colors.
 */
type variant = "muted" | "minimal"

export default function AvatarBadge({
  text,
  small,
  position,
  textClassName,
  variant,
}: {
  text: string
  small?: boolean
  position?: Position
  textClassName?: string
  variant?: variant
}) {
  if (position === "vertical") {
    return (
      <div
        className={cn(
          "text-xs text-muted-foreground text-center mt-1 flex justify-center text-nowrap font-sans",
          textClassName
        )}
      >
        {text}
      </div>
    )
  }

  return (
    <Badge
      variant="muted"
      className={cn(
        small ? "h-6" : "h-8",
        "z-10 w-auto text-sm font-normal flex justify-center items-center px-2 !-ml-1 border-l-[3px] border-y-[1px] border-l-white dark:border-l-background hover:bg-slate-200 dark:hover:bg-slate-900",
        variant === "minimal" && "bg-transparent border-0",
        textClassName
      )}
    >
      {text}
    </Badge>
  )
}
